var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.01,16.25l-6.01,6.01-6.01-6.01c-1.19-1.19-2-2.7-2.33-4.35-.33-1.65-.16-3.36.48-4.91s1.73-2.88,3.13-3.81c1.4-.93,3.04-1.43,4.72-1.43s3.32.5,4.72,1.43c1.4.93,2.49,2.26,3.13,3.81s.81,3.26.48,4.91c-.33,1.65-1.14,3.16-2.33,4.35Zm-6.01-2.23c1,0,1.96-.4,2.67-1.11.71-.71,1.11-1.67,1.11-2.67s-.4-1.96-1.11-2.67c-.71-.71-1.67-1.11-2.67-1.11s-1.96.4-2.67,1.11c-.71.71-1.11,1.67-1.11,2.67s.4,1.96,1.11,2.67c.71.71,1.67,1.11,2.67,1.11Zm0-1.89c-.5,0-.98-.2-1.34-.55-.35-.35-.55-.83-.55-1.34s.2-.98.55-1.34c.35-.35.83-.55,1.34-.55s.98.2,1.34.55c.35.35.55.83.55,1.34s-.2.98-.55,1.34c-.35.35-.83.55-1.34.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b0a19561c2a5532f5a7907956591ee0a.svg";
export { ForwardRef as ReactComponent };